import React from 'react'

const Phonepe = () => {
  return (
    <div>Phonepe</div>
  )
}

export default Phonepe